/* eslint-disable no-unused-vars */
import React from 'react';
import { Dialog, DialogContent, IconButton, Grid, Tooltip, InputAdornment, Box, Checkbox } from '@mui/material';
import styles from 'custom/style.module.css';
import { CustomButton, CustomTextField, CustomDialogTitle, CustomDialogAction, CustomInputLabel, StyledCard, InputProps, CustomCheckbox } from 'custom/components';
import { BrowseIcon, CloseIconBtn } from 'custom/constants';

const ExtractionResultModal = (props) => {
  const { modal, onClose, fields, errors, onSubmit, onChange } = props;

  return (
    <div>
      <Dialog aria-labelledby='form-dialog-title' open={modal === 'reject_extraction' || modal === 'approve_extraction'} onClose={onClose} maxWidth={'sm'} fullWidth>
        <CustomDialogTitle id='form-dialog-title'>
          {modal === 'reject_extraction' ? 'Reject Extraction' : 'Approve Extraction'}
          <CloseIconBtn onClick={onClose} />
        </CustomDialogTitle>
        { modal === 'approve_extraction' && (
          <Box component='form' 
            onSubmit={(e) => { e.preventDefault(); onSubmit('approve'); }} 
            autoComplete='off'>
            <DialogContent>
              <StyledCard sx={{ mt: 2 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} >
                    <CustomInputLabel htmlFor='name' required>Name for Extracted Data</CustomInputLabel>
                    <CustomTextField
                      {...InputProps}
                      fullWidth
                      id='name'
                      placeholder='Name'
                      type='text'
                      name='name'
                      onChange={onChange}
                      value={fields.name || ''}
                      error={Boolean(errors.name || errors.remark)}
                      helperText={errors.name || errors.remark}
                    />
                  </Grid>
                  <Grid item xs={12} >
                    <CustomInputLabel htmlFor='description' required>Description</CustomInputLabel>
                    <CustomTextField
                      {...InputProps}
                      fullWidth
                      id='description'
                      placeholder='Description'
                      type='text'
                      name='description'
                      onChange={onChange}
                      value={fields.description || ''}
                      error={Boolean(errors.description)}
                      helperText={errors.description }
                    />
                  </Grid>
                  <Grid item xs={12} >
                    <CustomInputLabel htmlFor='notes' required>Notes</CustomInputLabel>
                    <CustomTextField
                      {...InputProps}
                      fullWidth
                      id='notes'
                      placeholder='Notes'
                      type='text'
                      name='notes'
                      multiline
                      rows={2}
                      onChange={onChange}
                      value={fields.notes || ''}
                      error={Boolean(errors.notes)}
                      helperText={errors.notes}
                    />
                  </Grid>
                </Grid>
              </StyledCard>
            </DialogContent>
            <CustomDialogAction className={`${styles.fSpaceBtw}`}>
              <CustomButton variant='contained' type='reset' onClick={props.onClose}> Close </CustomButton>
              {/* <CustomButton variant='contained' onClick={onSubmit}> Submit </CustomButton> */}
              <CustomButton variant='contained' type='submit'> Submit </CustomButton>
            </CustomDialogAction>
          </Box>
        )}

        { modal === 'reject_extraction' && (
          <Box component='form' 
            onSubmit={(e) => { e.preventDefault(); onSubmit('reject'); }} 
            autoComplete='off'>
            <DialogContent>
              <StyledCard sx={{ mt: 2 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} >
                    <CustomInputLabel htmlFor='name' required>Reason</CustomInputLabel>
                    <CustomTextField
                      {...InputProps}
                      fullWidth
                      id='reason'
                      placeholder='Reason'
                      type='text'
                      name='reason'
                      onChange={onChange}
                      value={fields.reason || ''}
                      error={Boolean(errors.reason || errors.remark)}
                      helperText={errors.reason || errors.remark}
                    />
                  </Grid>
                  <Grid item xs={12} >
                    <CustomCheckbox
                      control={
                        <Checkbox inputProps={{ 'aria-label': '', }} 
                          checked={fields.requestNewRefinement || false} 
                          onChange={onChange} 
                          name='requestNewRefinement' 
                          disableRipple />
                      }
                      label='Request New'
                    />
                  </Grid>
                </Grid>
              </StyledCard>
            </DialogContent>
            <CustomDialogAction className={`${styles.fSpaceBtw}`}>
              <CustomButton variant='contained' type='reset' onClick={props.onClose}> Close </CustomButton>
              <CustomButton variant='contained' type='submit'> Submit </CustomButton>
            </CustomDialogAction>
          </Box>
        )}

      </Dialog>
    </div>
  );
};
export default ExtractionResultModal;